import {
  OptionRecord,
  PartialScreenWithCoveragesRecord,
  ScreenWithCoverages,
} from "../../../types";

enum MineSubsidenceScheduledOption {
  Default = "Default",
  Illinois = "Illinois",
}

const mineSubsidenceScheduledDescription: OptionRecord<
  MineSubsidenceScheduledOption,
  PartialScreenWithCoveragesRecord
> = {
  [MineSubsidenceScheduledOption.Default]: {
    [ScreenWithCoverages.PlanDetails]:
      "Provides coverage for the collapse of an underground coal mine that causes damage to your structure.",
    [ScreenWithCoverages.ExtraCoverages]:
      "Provides coverage for the collapse of an underground coal mine that causes damage to your structure.",
  },
  [MineSubsidenceScheduledOption.Illinois]: {
    [ScreenWithCoverages.PlanDetails]:
      "Provides coverage for the collapse of an underground mine that causes damage to your structure.",
    [ScreenWithCoverages.ExtraCoverages]:
      "Provides coverage for the collapse of an underground mine that causes damage to your structure.",
  },
};

const mineSubsidenceScheduledTooltip: OptionRecord<
  MineSubsidenceScheduledOption,
  PartialScreenWithCoveragesRecord
> = {
  [MineSubsidenceScheduledOption.Default]: {
    [ScreenWithCoverages.PlanDetails]:
      "Coverage is provided for your listed other structures on permanent foundations.",
    [ScreenWithCoverages.ExtraCoverages]:
      "Coverage is provided for your listed other structures on permanent foundations.",
    [ScreenWithCoverages.PolicySummary]:
      "Coverage is provided for your listed other structures on permanent foundations.",
  },
  [MineSubsidenceScheduledOption.Illinois]: {
    [ScreenWithCoverages.PlanDetails]:
      "Protects your home and other structures from damage caused by ground movement due to underground man-made mines- such as coal, clay, limestone, or fluorspar mines. This only applies to mine-related causes, not natural events like earthquakes or issues like poor soil drainage.",
    [ScreenWithCoverages.ExtraCoverages]:
      "Protects your home and other structures from damage caused by ground movement due to underground man-made mines- such as coal, clay, limestone, or fluorspar mines. This only applies to mine-related causes, not natural events like earthquakes or issues like poor soil drainage.",
    [ScreenWithCoverages.PolicySummary]:
      "Protects your home and other structures from damage caused by ground movement due to underground man-made mines- such as coal, clay, limestone, or fluorspar mines. This only applies to mine-related causes, not natural events like earthquakes or issues like poor soil drainage.",
  },
};

const getMineSubsidenceScheduledDescription = (
  mineSubsidenceScheduledOption: MineSubsidenceScheduledOption,
  screen: ScreenWithCoverages
): string | undefined =>
  mineSubsidenceScheduledDescription[mineSubsidenceScheduledOption]
    ? mineSubsidenceScheduledDescription[mineSubsidenceScheduledOption][screen]
    : mineSubsidenceScheduledDescription[MineSubsidenceScheduledOption.Default][
        screen
      ];

const getMineSubsidenceScheduledTooltip = (
  mineSubsidenceScheduledOption: MineSubsidenceScheduledOption,
  screen: ScreenWithCoverages
): string | undefined =>
  mineSubsidenceScheduledTooltip[mineSubsidenceScheduledOption]
    ? mineSubsidenceScheduledTooltip[mineSubsidenceScheduledOption][screen]
    : mineSubsidenceScheduledTooltip[MineSubsidenceScheduledOption.Default][
        screen
      ];

export {
  MineSubsidenceScheduledOption,
  getMineSubsidenceScheduledDescription,
  getMineSubsidenceScheduledTooltip,
};
